//! Common
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const TOGGLE_BUTTON_LOADING = 'TOGGLE_BUTTON_LOADING';
export const SET_SCREEN_SCROLL = 'SET_SCREEN_SCROLL';
export const SET_SOCKET_CONNECTION_STATUS = 'SET_SOCKET_CONNECTION_STATUS';
export const OPEN_DOWNLOAD_OUR_APP_MODAL = 'OPEN_DOWNLOAD_OUR_APP_MODAL';
export const CLOSE_DOWNLOAD_OUR_APP_MODAL = 'CLOSE_DOWNLOAD_OUR_APP_MODAL';

//! Auth
export const TOGGLE_LOGIN_MODAL = 'TOGGLE_LOGIN_MODAL';
export const TOGGLE_SIGNUP_MODAL = 'TOGGLE_SIGNUP_MODAL';
export const SEND_LOGIN_OTP = 'SEND_LOGIN_OTP';
export const CUSTOMER_LOGIN = 'CUSTOMER_LOGIN';
export const CUSTOMER_SIGNUP = 'CUSTOMER_SIGNUP';
export const CUSTOMER_LOGOUT = 'CUSTOMER_LOGOUT';
export const TOGGLE_FORGET_PASSWORD_MODAL = 'TOGGLE_FORGET_PASSWORD_MODAL';

//* Customer Detail
export const UPDATE_CUSTOMER_DETAILS = 'UPDATE_CUSTOMER_DETAILS';

export const GET_CUSTOMER_DETAILS = 'GET_CUSTOMER_DETAILS';
export const SET_CUSTOMER_DETAILS = 'SET_CUSTOMER_DETAILS';
export const GET_MILAN_SATHI_CUSTOMER_DETAILS = 'GET_MILAN_SATHI_CUSTOMER_DETAILS';
export const SET_MILAN_SATHI_CUSTOMER_DETAILS = 'SET_MILAN_SATHI_CUSTOMER_DETAILS';

//* Address
export const GET_CUSTOMER_ADDRESS = 'GET_CUSTOMER_ADDRESS';
export const SET_CUSTOMER_ADDRESS = 'SET_CUSTOMER_ADDRESS';
export const CREATE_CUSTOMER_ADDRESS = 'CREATE_CUSTOMER_ADDRESS';
export const UPDATE_CUSTOMER_ADDRESS = 'UPDATE_CUSTOMER_ADDRESS';
export const DELETE_CUSTOMER_ADDRESS = 'DELETE_CUSTOMER_ADDRESS';

//* History
export const GET_RECHARGE_HISTORY = "GET_RECHARGE_HISTORY";
export const SET_RECHARGE_HISTORY = "SET_RECHARGE_HISTORY";

export const GET_YATRA_HISTORY = "GET_YATRA_HISTORY";
export const SET_YATRA_HISTORY = "SET_YATRA_HISTORY";

export const GET_PRODUCT_HISTORY = "GET_PRODUCT_HISTORY";
export const SET_PRODUCT_HISTORY = "SET_PRODUCT_HISTORY";

export const GET_PUJA_HISTORY = "GET_PUJA_HISTORY";
export const SET_PUJA_HISTORY = "SET_PUJA_HISTORY";

export const GET_PITR_PAKSHA_HISTORY = 'GET_PITR_PAKSHA_HISTORY';
export const SET_PITR_PAKSHA_HISTORY = 'SET_PITR_PAKSHA_HISTORY';


//! Recharge
export const GET_RECHARGE_SERVICE_LIST = 'GET_RECHARGE_SERVICE_LIST';
export const SET_RECHARGE_SERVICE_LIST = 'SET_RECHARGE_SERVICE_LIST';
export const HANDLE_RECHARGE = 'HANDLE_RECHARGE';
export const HANDLE_BILL_RECHARGE = 'HANDLE_BILL_RECHARGE';

//! Milan Sathi
export const GET_MILAN_SATHI_PROFILE = 'GET_MILAN_SATHI_PROFILE';
export const SET_MILAN_SATHI_PROFILE = 'SET_MILAN_SATHI_PROFILE';

export const SEND_CONNECTION_REQUEST = 'SEND_CONNECTION_REQUEST';

//! Sanchar
export const GET_CATEGORY = 'GET_CATEGORY';
export const SET_CATEGORY = 'SET_CATEGORY';
export const GET_SUB_CATEGORY = 'GET_SUB_CATEGORY';
export const SET_SUB_CATEGORY = 'SET_SUB_CATEGORY';
export const GET_DATA_BY_SUB_CATEGORY = 'GET_DATA_BY_SUB_CATEGORY';
export const SET_DATA_BY_SUB_CATEGORY = 'SET_DATA_BY_SUB_CATEGORY';
export const GET_PODCAST_BY_SUB_CATEGORY = 'GET_PODCAST_BY_SUB_CATEGORY';
export const SET_PODCAST_BY_SUB_CATEGORY = 'SET_PODCAST_BY_SUB_CATEGORY';

//* News
export const GET_BREAKING_NEWS = 'GET_BREAKING_NEWS';
export const SET_BREAKING_NEWS = 'SET_BREAKING_NEWS';
export const GET_NEWS_CATEGORY = 'GET_NEWS_CATEGORY';
export const SET_NEWS_CATEGORY = 'SET_NEWS_CATEGORY';
export const GET_NEWS_BY_CATEGORY = 'GET_NEWS_BY_CATEGORY';
export const SET_NEWS_BY_CATEGORY = 'SET_NEWS_BY_CATEGORY';

//* Live
export const GET_LIVE_VIDEO = 'GET_LIVE_VIDEO';
export const SET_LIVE_VIDEO = 'SET_LIVE_VIDEO';

//* Daily Darshan
export const GET_DAILY_DARSHAN = "GET_DAILY_DARSHAN";
export const SET_DAILY_DARSHAN = "SET_DAILY_DARSHAN";

//* Consultancy
export const CREATE_CONSULTANCY = "CREATE_CONSULTANCY";

//! Ecommerce
//* Yatra
export const GET_YATRA = "GET_YATRA";
export const SET_YATRA = "SET_YATRA";
export const GET_YATRA_DETAILS = "GET_YATRA_DETAILS";
export const SET_YATRA_DETAILS = "SET_YATRA_DETAILS";
export const BOOK_YATRA = "BOOK_YATRA";

//* Product
export const GET_PRODUCT_CATEGORY = "GET_PRODUCT_CATEGORY";
export const SET_PRODUCT_CATEGORY = "SET_PRODUCT_CATEGORY";
export const GET_PRODUCT = "GET_PRODUCT";
export const SET_PRODUCT = "SET_PRODUCT";

export const ADD_PRODUCT_TO_CART = 'ADD_PRODUCT_TO_CART';
export const UPDATE_PRODUCT_CART = 'UPDATE_PRODUCT_CART';
export const GET_PRODUCT_CART = 'GET_PRODUCT_CART';
export const SET_PRODUCT_CART = 'SET_PRODUCT_CART';
export const BOOK_PRODUCT_CART = 'BOOK_PRODUCT_CART';

export const BOOK_PITR_PAKSHA = 'BOOK_PITR_PAKSHA';

//* Puja
export const GET_PUJA = "GET_PUJA";
export const SET_PUJA = "SET_PUJA";

export const BOOK_PUJA = "BOOK_PUJA";

//! Static Page
export const GET_TERMS_OF_USE = 'GET_TERMS_OF_USE';
export const SET_TERMS_OF_USE = 'SET_TERMS_OF_USE';
export const GET_PRIVACY_POLICY = 'GET_PRIVACY_POLICY';
export const SET_PRIVACY_POLICY = 'SET_PRIVACY_POLICY';
export const GET_REFUND_POLICY = 'GET_REFUND_POLICY';
export const SET_REFUND_POLICY = 'SET_REFUND_POLICY';
export const GET_ABOUT_US = 'GET_ABOUT_US';
export const SET_ABOUT_US = 'SET_ABOUT_US';